import React from 'react';
import { routes } from 'constants/config';
import { Button } from 'components/ui';
import usePermissions from 'hooks/usePermissions';

const ActionButton = () => {
  const { isPermitted: canCreateOwnEvents } = usePermissions({
    type: 'in_person_training/event',
    action: 'create',
  });
  if (canCreateOwnEvents) {
    return (
      <div className="Index-newButtonsContainer">
        <Button
          icon="add"
          url={routes.IN_PERSON_TRAINING.NEW_EVENT}
          aria-label="Add New Event Button"
          pendoClassName="trk_button_learning_new-event"
        >
          {t('in_person_training.events.new_event')}
        </Button>
      </div>
    );
  }

  return <></>;
};

export default ActionButton;
